<template>
  <v-row class="estilo-resumen">
    <v-col cols="12" md="6" v-if="resumenParte">
      <v-card outlined>
        <v-card-title> Horas de sistemas en este parte </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                hint="No facturable"
                persistent-hint
                readonly
                :value="noFacturable"
                class="v-input--is-focused no-facturable"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                hint="Facturable"
                persistent-hint
                readonly
                :value="facturable"
                class="v-input--is-focused facturable"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                hint="Horas reales"
                persistent-hint
                readonly
                :value="horasReales"
                class="v-input--is-focused reales"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                hint="Horas ponderadas"
                persistent-hint
                readonly
                :value="horasPonderadas"
                class="v-input--is-focused ponderadas"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                hint="Ppto. cerrado"
                persistent-hint
                readonly
                :value="pptoCerrado"
                class="v-input--is-focused ponderadas"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- <v-col cols="12" sm="6" md="6"> -->
    <v-col>
      <ResumenCliente
        :loading="loadingEstadoContratos"
      />
    </v-col>
    <v-col cols="12" v-if="resumenParte">
      <v-card outlined>
          <v-card-title> Horas de desarrollo en este parte </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  hint="Horas reales"
                  persistent-hint
                  readonly
                  :value="horasRealesDesarrollo"
                  class="v-input--is-focused reales"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  hint="Horas ponderadas"
                  persistent-hint
                  readonly
                  :value="horasPonderadasDesarrollo"
                  class="v-input--is-focused ponderadas"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import ResumenCliente from "../resumen/resumenCliente.vue"
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
  name: "Resumen",
  props: [
    "parte",
    "contratos",
    "ambitos",
    "acciones",
    "accionesModificadas",
    "delegacion_id",
    "delegaciones",
    "usuarios",
    "gradosUrgencia",
    "gradourgencia",
    "resumenParte",
    "timer",
    "contrato",
    "opcionesAccion",
    "ambito",
  ],
  components: {
    ResumenCliente
  },
  data() {
    return {
      fechaHoy: new Date().toISOString().substr(0, 10),
      loadingEstadoContratos: true,
      nivelesMorosidad: [],
    };
  },
  methods: {
    ...mapActions("resumen", ["setEsMoroso"]),
    ...mapActions('contratos', ['getEstadoContratosCliente', 'setContratosCliente']),
    getPosicionIdContrato(id) {
      //Devuelve la posición del array usuarios del id Usuario que se le pasa
      return this.contratos.findIndex((x) => x.id === id);
    },
    calcularHorasPonderadas(accion) {
      // Hola, Sergio al aparato! 
      // Esta función se ha refactorizado para calcular las horas ponderadas en el momento de guardar la acción, la función está dentro del componente acciones.
      // Todas las acciones tienen la propiedad horasPonderadas con el cálculo ya hecho, es cuestión de sumar las horas ponderadas de todas las acciones.
      // En las acciones guardadas desde los timers es posible que no se calcule, pero al guardar la acción y recuperarla de laravel, laravel sí que pasa
      // esa propiedad con el cálculo hecho.
      // ---
      // Habría que revisar esta función y mirar de quitarla de este componente (Resumen).
      // He visto que se utiliza en varias partes del código (algunas hacen referencia a timers?) y habría que mirarlo con calma.

      let tiempoAccionPonderado = 0;
      let entrada = null;
      let salida = null;
      if (this.resumenParte) {
        entrada = new Date(accion.fecha + " " + accion.entrada);
        salida = new Date(accion.fecha + " " + accion.salida);
      } else {
        entrada = new Date(accion.fechaFD + " " + accion.inicioTimerFD);
        salida = new Date(accion.fechaFD + " " + accion.finTimerFD);
      }
      if (entrada > salida) {
        //Si la entrada es después de la salida sumamos un dia a la salida para que calcule bien el tiempo
        salida.setDate(salida.getDate() + 1);
      }

      let tiempoAccion = (salida.getTime() - entrada.getTime()) / 3600000;

      if (
        (this.resumenParte && accion.asistencia_minima) ||
        (!this.resumenParte && this.opcionesAccion.asistencia_minima)
      ) {
        tiempoAccion = 1;
      }

      if (this.resumenParte) {
        let indiceUsuarioAccion = this.usuarios.findIndex(
          (x) => x.id === accion.user.id
        );
        let factorTecnico =
          this.usuarios[indiceUsuarioAccion].tipo_usuario.valor;

        let indiceUrgenciaAccion = this.gradosUrgencia.findIndex(
          (x) => x.id === accion.urgencia.id
        );
        let factorUrgencia = this.gradosUrgencia[indiceUrgenciaAccion].factor;

        let indiceAmbitoAccion = this.ambitos.findIndex(
          (x) => x.id === accion.ambito.id
        );

        // Al vincular los contratos con los ámbitos ahora es posible que cambiando el contrato el ámbito se quede vacío
        // (el ámbito que había seleccionado no existe en el nuevo contrato seleccionado), en ese caso
        // no se puede calcular el tiempo a descontar porque no está informado el ámbito. Con esto, el cálculo dará 0 hasta que el usuario especifique el ámbito
        let factorAmbito = 0;
        // findIndex devuelve -1 cuando no ha encontrado lo que busca
        if (indiceAmbitoAccion >= 0) {
          factorAmbito = this.ambitos[indiceAmbitoAccion].servicio.factor;
        }

        let indiceDelegacionAccion = this.delegaciones.findIndex(
          (x) => x.delegacionId === this.parte.delegacion_id
        );
        let factorDesplazamiento = 0;
        if(accion.desplazamiento){
          if(indiceDelegacionAccion !== -1){
            factorDesplazamiento = this.delegaciones[indiceDelegacionAccion].factor;
          }
        }
        // console.log(this.getArrayPositionByItemId(this.accionesModificadas, accion.id));
        // Verificamos si es una acción guardada en BBDD
        if (typeof accion.id === "number") {
          let indiceAccionModificada = this.parte.accionesModificadas.findIndex(
            (x) => x.id === accion.id
          );
          // console.log(indiceAccionModificada);
          // Verificamos si la acción ha sido modificada
          if (indiceAccionModificada === -1) {
            // No está en el array
            tiempoAccionPonderado =
              accion.horasPonderadas + accion.horasDesplazamiento;
          } else {
            tiempoAccionPonderado =
              tiempoAccion * factorTecnico * factorAmbito * factorUrgencia +
              factorDesplazamiento;
            if (accion.abono) {
              tiempoAccionPonderado = tiempoAccionPonderado * -1;
            }
          }
        } else {
          // Es una acción nueva
          tiempoAccionPonderado =
            tiempoAccion * factorTecnico * factorAmbito * factorUrgencia +
            factorDesplazamiento;
          if (accion.abono) {
            tiempoAccionPonderado = tiempoAccionPonderado * -1;
          }
        }
      } else {
        let factorTecnico = this.usuarios.find((t) => t.id === this.authUser.id)
          .tipo_usuario.valor;
        let factorUrgencia = this.gradosUrgencia.find(
          (gu) => gu.id === this.gradourgencia
        ).factor;

        // Al vincular los contratos con los ámbitos ahora es posible que cambiando el contrato el ámbito se quede vacío
        // (el ámbito que había seleccionado no existe en el nuevo contrato seleccionado), en ese caso
        // no se puede calcular el tiempo a descontar porque no está informado el ámbito. Con esto, el cálculo dará 0 hasta que el usuario especifique el ámbito
        let factorAmbito = 0;
        if (this.ambitos.find((a) => a.id === this.ambito) !== undefined) {
          factorAmbito = this.ambitos.find((a) => a.id === this.ambito).servicio
            .factor;
        }

        let factorDesplazamiento = this.delegaciones[0].factor;

        if (!this.opcionesAccion.desplazamiento) {
          factorDesplazamiento = 0;
        }

        tiempoAccionPonderado =
          tiempoAccion * factorTecnico * factorAmbito * factorUrgencia +
          factorDesplazamiento;


        if (this.opcionesAccion.abono) {
          tiempoAccionPonderado = tiempoAccionPonderado * -1;
        }
      }
      return tiempoAccionPonderado;
    },
    horasFinales(horasActuales) {
      // console.log(horasActuales);
      // console.log(this.calcularHorasPonderadas(this.timer).toFixed(2));
      return (
        horasActuales - this.calcularHorasPonderadas(this.timer).toFixed(2)
      );
    },
    contratoActual(id) {
      if (this.getPosicionIdContrato(id) !== -1 && id === this.contrato) {
        return true;
      }
      return false;
    },
    datosMorosidad(idMorosidad) {
      if (this.nivelesMorosidad.length !== 0) {
        return this.nivelesMorosidad.filter((n) => n.id === idMorosidad)[0];
      }
      return 1;
    },
    horasContratadasContrato(idContrato) {
      let contrato = this.contratos.find((c) => c.id === idContrato);
      if (contrato) {
        return contrato.horasContratadas;
      }
      return 0;
    },
    calculoMorosidad(idMorosidad, idContrato) {
      let valorMorosidad = this.datosMorosidad(idMorosidad).valor;
      let horasContratadas = this.horasContratadasContrato(idContrato);

      if (horasContratadas !== 0) {
        return (valorMorosidad * horasContratadas) / 100;
      }
    },
    datosIcono(horas, valor, contrato){
      if(horas <= this.calculoMorosidad(3, contrato)) { //morosidad 3
        let datosMorosidad = this.nivelesMorosidad.find(nm => nm.id === 3);
        if(valor === 'color'){ return  datosMorosidad.color }
        else if(valor === 'icono'){ return datosMorosidad.icono }
        else if(valor === 'mostrado') { return true }
        else if(valor === 'tipoMoroso') { return 'critico' }
      }
      else if(horas <= this.calculoMorosidad(2, contrato)) { //morosidad 2
        let datosMorosidad = this.nivelesMorosidad.find(nm => nm.id === 2);
        if(valor === 'color'){ return datosMorosidad.color }
        else if(valor === 'icono'){ return datosMorosidad.icono }
        else if(valor === 'mostrado') { return true }
        else if(valor === 'tipoMoroso') { return 'critico' }
      }
      else if(horas < this.datosMorosidad(1).valor) { //morosidad 1
        let datosMorosidad = this.nivelesMorosidad.find(nm => nm.id === 1);
        if(valor === 'color'){ return datosMorosidad.color }
        else if(valor === 'icono'){ return datosMorosidad.icono }
        else if(valor === 'mostrado') { return true }
        else if(valor === 'tipoMoroso') { return 'leve' }
      }
    },
    estadoContrato() {
      if (this.esMoroso) {
        this.setEsMoroso(false);
      }

      //Array con los tipos de morosidad que tiene el cliente en cada contrato al entrar
      let morosidadContratos = [this.datosIcono(this.cloud, 'tipoMoroso', 1), this.datosIcono(this.mantenimiento, 'tipoMoroso', 2),
      this.datosIcono(this.hosting, 'tipoMoroso', 4), this.datosIcono(this.secure, 'tipoMoroso', 5), this.datosIcono(this.backup, 'tipoMoroso', 6)];

      if(morosidadContratos.includes('critico')){ //si el array contiene algún contrato en critico
        return 'critico';  
      }else if (!this.resumenParte) { //Si estamos en el FullDialogTimer
        //miramos si al imputar la acción del timer el cliente se quedará en negatico
        let morosidadContratoActual = null; //variable que se llenará con el tipo de morosidad que tenga el contrato que esté marcado 
        if(this.contratoActual(1)){ morosidadContratoActual = this.datosIcono(this.horasFinales(this.cloud), 'tipoMoroso', 1); }
        else if(this.contratoActual(2)) { morosidadContratoActual = this.datosIcono(this.horasFinales(this.mantenimiento), 'tipoMoroso', 2) }
        else if(this.contratoActual(4)) { morosidadContratoActual = this.datosIcono(this.horasFinales(this.hosting), 'tipoMoroso', 4) }
        else if(this.contratoActual(5)) { morosidadContratoActual = this.datosIcono(this.horasFinales(this.secure), 'tipoMoroso', 5) }
        else if(this.contratoActual(6)) { morosidadContratoActual = this.datosIcono(this.horasFinales(this.backup), 'tipoMoroso', 6) }
        
        if(morosidadContratoActual === 'critico' || morosidadContratoActual === 'leve'){
          return morosidadContratoActual;        
        }else {
          return false;
        }
      }else if(morosidadContratos.includes('leve')){ //si el array contiene algún contrato en leve
        return 'leve';
      }
      return false;
    }
  },
  async mounted(){
    let codCliente = this.parte.cliente_id;
    await this.getEstadoContratosCliente([this.fechaHoy, codCliente]);
    this.loadingEstadoContratos = false;
  },
  computed: {
    ...mapState("login", ["authUser"]),
    ...mapState("resumen", ["esMoroso"]),
    estiloHoras() {
      if(this.$vuetify.theme.dark){
        return 'font-size: 2.2em; color: white;';
      }else {
        return 'font-size: 2.2em; color: black;';
      }
    },
    horasReales() {
      let horasReales = 0;
      this.acciones.forEach((accion) => {
        if (!accion.abono && accion.contrato.id !== 8) { //no tenemos en cuenta los abonos ni las acciones de contrato "desarrollo"
        // if (!accion.abono) {
          let entrada = new Date(accion.fecha + " " + accion.entrada);
          let salida = new Date(accion.fecha + " " + accion.salida);
          let tiempoAccion = (salida.getTime() - entrada.getTime()) / 3600000;
          // console.log(tiempoAccion);
          horasReales += tiempoAccion;
        }
      });
      return Math.round(horasReales * 100) / 100;
    },
    horasRealesDesarrollo() {
      let horasReales = 0;
      this.acciones.forEach((accion) => {
        if (!accion.abono && accion.contrato.id === 8) { //solo tenemos en cuenta las acciones con contrato "desarrollo"
          let entrada = new Date(accion.fecha + " " + accion.entrada);
          let salida = new Date(accion.fecha + " " + accion.salida);
          let tiempoAccion = (salida.getTime() - entrada.getTime()) / 3600000;
          horasReales += tiempoAccion;
        }
      });
      return Math.round(horasReales * 100) / 100;
    },
    horasPonderadas() {
      let horasPonderadas = 0;
      this.acciones.forEach((accion) => {
        if (accion.contrato.id !== 10 && accion.contrato.id !== 8) {
          // Las acciones de contrato "no facturable" y "desarrollo" se ignoran en el cálculo de las horas ponderadas de sistemas
          horasPonderadas += this.calcularHorasPonderadas(accion);
          // console.log("-->: " + horasPonderadas);
        }
      });
      return Math.round(horasPonderadas * 100) / 100;
    },
    horasPonderadasDesarrollo() {
      let horasPonderadas = 0;
      this.acciones.forEach((accion) => {
        if (accion.contrato.id === 8 ) {  //solo tenemos en cuenta las acciones con contrato "desarrollo"
          horasPonderadas += this.calcularHorasPonderadas(accion);
        }
      });
      return Math.round(horasPonderadas * 100) / 100;
    },
    facturable() {
      let horasPonderadas = 0;
      this.acciones.forEach((accion) => {
        if (accion.contrato.id === 9) {
          // let entrada = new Date(accion.fecha+' '+accion.entrada);
          // let salida = new Date(accion.fecha+' '+accion.salida);
          // let tiempoAccion = ((salida.getTime() - entrada.getTime())/3600000);
          // console.log(tiempoAccion);
          // horasFacturables += tiempoAccion;
          horasPonderadas += this.calcularHorasPonderadas(accion);
        }
      });
      return Math.round(horasPonderadas * 100) / 100;
    },
    noFacturable() {
      let horasNoFacturables = 0;
      this.acciones.forEach((accion) => {
        if (accion.contrato.id === 10) {
          horasNoFacturables += this.calcularHorasPonderadas(accion);
        }
      });
      return Math.round(horasNoFacturables * 100) / 100;
    },
    cloud() {
      if (this.getPosicionIdContrato(1) !== -1) {
        let horasPonderadas =
          this.contratos[this.getPosicionIdContrato(1)].horas;
        if (this.resumenParte) {
          this.acciones.forEach((accion) => {
            if (accion.contrato.id === 1) {
              // Filtramos las acciones que son de contrato Cloud (id 1)
              horasPonderadas -= this.calcularHorasPonderadas(accion);
            }
          });
        }
        return Math.round(horasPonderadas * 100) / 100;
      }
      return 0;
    },
    mantenimiento() {
      if (this.getPosicionIdContrato(2) !== -1) {
        let horasPonderadas =
          this.contratos[this.getPosicionIdContrato(2)].horas;
        if (this.resumenParte) {
          this.acciones.forEach((accion) => {
            if (accion.contrato.id === 2) {
              // Filtramos las acciones que son de contrato Mantenimiento (id 2)
              horasPonderadas -= this.calcularHorasPonderadas(accion);
            }
          });
        }
        return Math.round(horasPonderadas * 100) / 100;
      }
      return 0;
    },
    pack() {
      if (this.getPosicionIdContrato(3) !== -1) {
        let horasPonderadas =
          this.contratos[this.getPosicionIdContrato(3)].horas;
        if (this.resumenParte) {
          this.acciones.forEach((accion) => {
            if (accion.contrato.id === 3) {
              // Filtramos las acciones que son de contrato Pack (id 3)
              horasPonderadas -= this.calcularHorasPonderadas(accion);
            }
          });
        }
        return Math.round(horasPonderadas * 100) / 100;
      }
      return 0;
    },
    hosting() {
      if (this.getPosicionIdContrato(4) !== -1) {
        let horasPonderadas =
          this.contratos[this.getPosicionIdContrato(4)].horas;
        if (this.resumenParte) {
          this.acciones.forEach((accion) => {
            if (accion.contrato.id === 4) {
              // Filtramos las acciones que son de contrato Hosting (id 4)
              horasPonderadas -= this.calcularHorasPonderadas(accion);
            }
          });
        }
        return Math.round(horasPonderadas * 100) / 100;
      }
      return 0;
    },
    secure() {
      if (this.getPosicionIdContrato(5) !== -1) {
        let horasPonderadas =
          this.contratos[this.getPosicionIdContrato(5)].horas;
        if (this.resumenParte) {
          this.acciones.forEach((accion) => {
            if (accion.contrato.id === 5) {
              // Filtramos las acciones que son de contrato Secure (id 5)
              horasPonderadas -= this.calcularHorasPonderadas(accion);
            }
          });
        }
        return Math.round(horasPonderadas * 100) / 100;
      }
      return 0;
    },
    backup() {
      if (this.getPosicionIdContrato(6) !== -1) {
        let horasPonderadas =
          this.contratos[this.getPosicionIdContrato(6)].horas;
        if (this.resumenParte) {
          this.acciones.forEach((accion) => {
            if (accion.contrato.id === 6) {
              // Filtramos las acciones que son de contrato Backup Online (id 6)
              horasPonderadas -= this.calcularHorasPonderadas(accion);
            }
          });
        }
        return Math.round(horasPonderadas * 100) / 100;
      }
      return 0;
    },
    pptoCerrado() {
      if (this.getPosicionIdContrato(9) !== -1) {
        let horasPonderadas =
          this.contratos[this.getPosicionIdContrato(7)].horas;
        if (this.resumenParte) {
          this.acciones.forEach((accion) => {
            if (accion.contrato.id === 7) {
              // Filtramos las acciones que son de Ppto. cerrado (id 7)
              horasPonderadas += this.calcularHorasPonderadas(accion);
            }
          });
        }
        return Math.round(horasPonderadas * 100) / 100;
      }
      return 0;
    },
    desarrollo() {
      if (this.getPosicionIdContrato(8) !== -1) {
        let horasPonderadas =
          this.contratos[this.getPosicionIdContrato(8)].horas;
        if (this.resumenParte) {
          this.acciones.forEach((accion) => {
            if (accion.contrato.id === 8) {
              // Filtramos las acciones que son de contrato Desarrollo (id 8)
              horasPonderadas -= this.calcularHorasPonderadas(accion);
            }
          });
        }
        return Math.round(horasPonderadas * 100) / 100;
      }
      return 0;
    },
  },
  async created() {
    let respuesta = await axios.get("/api/rangoAvisosHorasNegativas");
    this.nivelesMorosidad = respuesta.data;

    // PRPBISIONAL-------------------------------------------------------------------
    // let contrato = this.contratos.filter(c => c.id == 1)[0]
    // if(contrato){
    //   contrato.horasContratadas = 10
    // }
    // contrato = this.contratos.filter(c => c.id == 2)[0]
    // if(contrato){
    //   contrato.horasContratadas = 10
    // }
    // contrato = this.contratos.filter(c => c.id == 4)[0]
    // if(contrato){
    //   contrato.horasContratadas = 5
    // }
    // contrato = this.contratos.filter(c => c.id == 5)[0]
    // if(contrato){
    //   contrato.horasContratadas = 10
    // }
    // contrato = this.contratos.filter(c => c.id == 6)[0]
    // if(contrato){
    //   contrato.horasContratadas = 10
    // }
    //--------------------------------------------------------------------------------
    this.setEsMoroso(this.estadoContrato());
  },
  watch: {},
};
</script>
<style>
.estilo-resumen .v-text-field input {
  font-size: 2.2em;
}
.v-application .facturable {
  color: #18bc9c !important;
  caret-color: #18bc9c !important;
}
.estilo-resumen .facturable .v-messages__message {
  color: #18bc9c;
}
.v-application .no-facturable {
  color: #e43133 !important;
  caret-color: #e43133 !important;
}
.estilo-resumen .no-facturable .v-messages__message {
  color: #e43133;
}
.v-application .mantenimiento {
  color: #a991d4 !important;
  caret-color: #a991d4 !important;
}
.estilo-resumen .mantenimiento .v-messages__message {
  color: #a991d4;
}
.v-application .pack {
  color: #bcb01b !important;
  caret-color: #bcb01b !important;
}
.estilo-resumen .pack .v-messages__message {
  color: #bcb01b;
}
.v-application .cloud {
  color: #f39c12 !important;
  caret-color: #f39c12 !important;
}
.estilo-resumen .cloud .v-messages__message {
  color: #f39c12;
}
.v-application .hosting {
  color: #0cb658 !important;
  caret-color: #0cb658 !important;
}
.estilo-resumen .hosting .v-messages__message {
  color: #0cb658;
}
.v-application .reales {
  color: #7945bd !important;
  caret-color: #7945bd !important;
}
.estilo-resumen .reales .v-messages__message {
  color: #7945bd;
}
.v-application .ponderadas {
  color: #3490dc !important;
  caret-color: #3490dc !important;
}
.estilo-resumen .ponderadas .v-messages__message {
  color: #3490dc;
}
.estilo-resumen .v-messages__message {
  text-align: end;
}
.estilo-resumen .v-text-field__slot > input {
  text-align: end;
}
.centradoVertical {
  width: max-content;
  display: flex;
}
</style>